
import Cup from "../../../assets/filled/Cup.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CupIcon({ className, dataTestid = "CupIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Cup data-testid={dataTestid} className={classes} {...rest} />
  );
}
